function CollapseView({ logs }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>Date and Time:</strong>{" "}
          {logs.created &&
            new Date(logs.created).toLocaleString("en-US", {
              month: "long", // March
              day: "numeric", // 2
              year: "numeric", // 2025
              hour: "numeric", // 5
              minute: "2-digit", // 15
              hour12: true, // am/pm
            })}
        </p>
        <p className="mb-1">
          <strong>User:</strong> {logs?.user?.email}
        </p>
        <p className="mb-1">
          <strong>Adjustment Type:</strong> {logs?.adjustmentType}
        </p>
        <p className="mb-1">
          <strong>Item Name:</strong> {logs?.itemName}
        </p>
        <p className="mb-1">
          <strong>Old Quantity:</strong> {logs?.oldQuantity}
        </p>
        <p className="mb-1">
          <strong>New Quantity:</strong> {logs?.newQuantity}
        </p>
      </div>
    </div>
  );
}

export default CollapseView;
